<template>
    <c-content>
        <section class="sign u-m-auto">
        <div class="sign__body">
            <header class="sign__header">
            <h1 class="sign__title">Cover</h1>
            <p class="sign__text">Register to your app account</p>
            </header>
            <c-form>
            <c-form-field label="Name">

                <c-form-input type="text" v-bind:status="$v.auth.name.$error ? 'danger' : ''" v-model="auth.name"></c-form-input>
                <span class="form-help u-color-danger" v-if="!$v.auth.name.required && $v.auth.name.$error">Field is required</span>

            </c-form-field>
            <c-form-field label="Email">
                <c-form-input type="email" v-bind:status="$v.auth.email.$error ? 'danger' : ''" v-model="auth.email"></c-form-input>
            </c-form-field> 
            <c-form-field label="Password">
                <c-form-input type="password" v-bind:status="$v.auth.password.$error ? 'danger' : ''" v-model="auth.password"></c-form-input>
            </c-form-field>
            <c-form-field label="Repeat Password">
                <c-form-input type="password"></c-form-input>
            </c-form-field>
            <c-button type="primary" @click.prevent="submit" block>Register</c-button>
            </c-form>
            <c-divider>OR</c-divider>
            <div class="u-text-center">
            <a href="#" class="u-color-muted u-ml-10 u-mr-10"><i class="icon-facebook2"></i></a>
            <a href="#" class="u-color-muted u-ml-10 u-mr-10"><i class="icon-twitter"></i></a>
            <a href="#" class="u-color-muted u-ml-10 u-mr-10"><i class="icon-github"></i></a>
            </div>
        </div>
        <footer class="sign__footer u-text-center">
            <p>Already have an account? <router-link to="/auth/login">Login in</router-link></p>
            <p class="u-text-muted u-fs-12">Dashboard UI kit by 20Theme<br>© 2017-2018. All RIGHT RESERVED.</p>
        </footer>
        </section>
    </c-content>
</template>


<script>
import { required, email } from "vuelidate/lib/validators";
import config from '../../../config';

export default {
    data() {
        return{
            auth: {
                name: "",
                email: "",
                password: ""
            }
        }
    },

    validations: {
        auth: {
            name: { required },
            email: { required, email },
            password: { required },
        }
    },

    methods: {

        submit() {

            let _this = this;
            this.$v.auth.$touch();
            // if its still pending or an error is returned do not submit
            if (this.$v.auth.$pending || this.$v.auth.$error) return;
            // to form submit after this
            
            this.$axios({url: config.API_URL + '/users/register', data: _this.auth, method: 'POST'})
            .then(function(resp){
                if(resp.data.status == 'ok'){
                    _this.$toast.succeed('registration successfully completed!', 2000);
                    
                    setTimeout(() => {
                        _this.$router.replace('/auth/login');
                    }, 2300);

                }
            })
            .catch(function(err){
                alert(err);
            })


        }

    }


}
</script>